webpackJsonp([189533322621937],{

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin-top: 0;\n  margin-bottom: ", ";\n\n  h1 {\n    margin-top: 0;\n    margin-bottom: .5rem;\n  }\n\n  p {\n    margin: 0 0 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"], ["\n  margin-top: 0;\n  margin-bottom: ", ";\n\n  h1 {\n    margin-top: 0;\n    margin-bottom: .5rem;\n  }\n\n  p {\n    margin: 0 0 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(4);
	var styles_1 = __webpack_require__(6);
	var StyledArticleGridHeader = styled_components_1.default.div(_templateObject, styles_1.dimensions.containerPadding);
	var ArticleGridHeader = function ArticleGridHeader(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	  return React.createElement(StyledArticleGridHeader, { className: className }, children);
	};
	exports.default = ArticleGridHeader;

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: space-between;\n  margin: 0 -.5rem;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: space-between;\n  margin: 0 -.5rem;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(4);
	var StyledCategoryGrid = styled_components_1.default.div(_templateObject);
	var CategoryGrid = function CategoryGrid(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	  return React.createElement(StyledCategoryGrid, { className: className }, children);
	};
	exports.default = CategoryGrid;

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  flex: 1 1 auto;\n  margin: .5rem;\n  padding: .25rem .5rem;\n  text-align: center;\n  background-color: ", ";\n"], ["\n  display: inline-block;\n  flex: 1 1 auto;\n  margin: .5rem;\n  padding: .25rem .5rem;\n  text-align: center;\n  background-color: ", ";\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(4);
	var gatsby_link_1 = __webpack_require__(43);
	var styles_1 = __webpack_require__(6);
	var StyledCategoryItem = styled_components_1.default(gatsby_link_1.default)(_templateObject, styles_1.colors.code);
	var CategoryItem = function CategoryItem(_ref) {
	  var name = _ref.name,
	      slug = _ref.slug,
	      className = _ref.className;
	  return React.createElement(StyledCategoryItem, { className: className, to: slug, href: slug }, name);
	};
	exports.default = CategoryItem;

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  width: auto;\n  max-width: 75em;\n"], ["\n  position: relative;\n  margin-left: auto;\n  margin-right: auto;\n  width: auto;\n  max-width: 75em;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(4);
	var StyledContainer = styled_components_1.default.div(_templateObject);
	var Container = function Container(_ref) {
	  var children = _ref.children,
	      className = _ref.className;
	  return React.createElement(StyledContainer, { className: className }, children);
	};
	exports.default = Container;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_helmet_1 = __webpack_require__(19);
	var Page_1 = __webpack_require__(21);
	var Container_1 = __webpack_require__(14);
	var ArticleGrid_1 = __webpack_require__(20);
	var ArticleGridHeader_1 = __webpack_require__(33);
	var CategoryGrid_1 = __webpack_require__(139);
	var CategoryItem_1 = __webpack_require__(140);
	var CategoriesPage = function CategoriesPage(_ref) {
	  var data = _ref.data;
	  return React.createElement(Page_1.default, null, React.createElement(react_helmet_1.default, null, React.createElement("title", null, data.site.siteMetadata.title), React.createElement("meta", { name: "description", content: data.site.siteMetadata.description }), React.createElement("meta", { property: "og:title", content: "Home" }), React.createElement("meta", { property: "og:description", content: data.site.siteMetadata.description })), React.createElement(Container_1.default, null, React.createElement(ArticleGrid_1.default, null, React.createElement(ArticleGridHeader_1.default, null, React.createElement("h1", null, "Filter berdasarkan kategori"), React.createElement(CategoryGrid_1.default, null, data.allMediumCategory.edges.map(function (_ref2) {
	    var node = _ref2.node;
	    return React.createElement(CategoryItem_1.default, { key: node.id, name: node.name, slug: node.fields.slug });
	  }))))));
	};
	exports.default = CategoriesPage;
	exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-categories-tsx-c0db1e7339e4bcb46262.js